export const nfseWebhookErrorMappings3 = {
    NFSE_WEBHOOK_INVALID_DIGITAL_SIGNATURE: {
        code: 'NFSE_WEBHOOK_INVALID_DIGITAL_SIGNATURE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Assinatura digital inválida. Verifique o certificado digital nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'Assinatura digital inválida. Verifique o certificado digital nas configurações.',
            },
            {
                language: 'en-US',
                message: 'Invalid digital signature. Please check the digital certificate in the settings.',
            },
            {
                language: 'es-ES',
                message: 'Firma digital inválida. Verifique el certificado digital en la configuración.',
            },
        ],
        technicalMessage: 'Assinatura digital inválida',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_DUPLICATE_RPS_IM_CNPJ: {
        code: 'NFSE_WEBHOOK_DUPLICATE_RPS_IM_CNPJ',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Já existe um RPS com o mesmo número, série e tipo para esta Inscrição Municipal/CNPJ. Verifique a numeração para evitar duplicidades.',
            },
            {
                language: 'pt-BR',
                message: 'Já existe um RPS com o mesmo número, série e tipo para esta Inscrição Municipal/CNPJ. Verifique a numeração para evitar duplicidades.',
            },
            {
                language: 'en-US',
                message: 'An RPS with the same number, series and type already exists for this Municipal Registration/CNPJ. Please check the numbering to avoid duplicates.',
            },
            {
                language: 'es-ES',
                message: 'Ya existe un RPS con el mismo número, serie y tipo para esta Inscripción Municipal/CNPJ. Verifique la numeración para evitar duplicados.',
            },
        ],
        technicalMessage: 'Para essa Inscrição Municipal/CNPJ já existe um RPS informado com o mesmo número',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_RPS_SEQUENCE_ERROR: {
        code: 'NFSE_WEBHOOK_RPS_SEQUENCE_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Erro na sequência de numeração do RPS. Verifique se não há falha na sequência e corrija a numeração nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'Erro na sequência de numeração do RPS. Verifique se não há falha na sequência e corrija a numeração nas configurações.',
            },
            {
                language: 'en-US',
                message: 'RPS numbering sequence error. Check for gaps in the sequence and correct the numbering in the settings.',
            },
            {
                language: 'es-ES',
                message: 'Error en la secuencia de numeración del RPS. Verifique si hay fallos en la secuencia y corrija la numeración en la configuración.',
            },
        ],
        technicalMessage: 'Erro com número sequencial',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_VERSION_NOT_SUPPORTED: {
        code: 'NFSE_WEBHOOK_VERSION_NOT_SUPPORTED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Versão do sistema não suportada pela prefeitura. O sistema deve usar a versão 2.04 ou mais recente. Entre em contato com o suporte.',
            },
            {
                language: 'pt-BR',
                message: 'Versão do sistema não suportada pela prefeitura. O sistema deve usar a versão 2.04 ou mais recente. Entre em contato com o suporte.',
            },
            {
                language: 'en-US',
                message: 'System version not supported by the city hall. The system must use version 2.04 or later. Please contact support.',
            },
            {
                language: 'es-ES',
                message: 'Versión del sistema no soportada por la alcaldía. El sistema debe usar la versión 2.04 o más reciente. Contacte al soporte.',
            },
        ],
        technicalMessage: 'E0-Versão Não Suportada',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_INVALID_FILE: {
        code: 'NFSE_WEBHOOK_INVALID_FILE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Arquivo inválido para emissão da NFS-e. Tente novamente ou entre em contato com o suporte.',
            },
            {
                language: 'pt-BR',
                message: 'Arquivo inválido para emissão da NFS-e. Tente novamente ou entre em contato com o suporte.',
            },
            {
                language: 'en-US',
                message: 'Invalid file for NFS-e issuance. Please try again or contact support.',
            },
            {
                language: 'es-ES',
                message: 'Archivo inválido para la emisión de NFS-e. Intente nuevamente o contacte al soporte.',
            },
        ],
        technicalMessage: 'E0-Arquivo inválido',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_CNPJ_NOT_FOUND: {
        code: 'NFSE_WEBHOOK_CNPJ_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Confira o CNPJ informado nas configurações. Caso esteja correto, o prestador pode não estar inscrito no município para emissão de NFS-e.',
            },
            {
                language: 'pt-BR',
                message: 'Confira o CNPJ informado nas configurações. Caso esteja correto, o prestador pode não estar inscrito no município para emissão de NFS-e.',
            },
            {
                language: 'en-US',
                message: 'Please verify the CNPJ in the settings. If it is correct, the service provider may not be registered in the municipality for NFS-e issuance.',
            },
            {
                language: 'es-ES',
                message: 'Verifique el CNPJ informado en la configuración. Si está correcto, el prestador puede no estar inscripto en el municipio para la emisión de NFS-e.',
            },
        ],
        technicalMessage: 'CNPJ não encontrado na base de dados',
        severity: 'error',
        critical: false,
    },
};
